/* projects/shared/src/lib/components/header/header.component.css */
.header-box-shadow {
  box-shadow:
    0 3px 5px -1px rgba(0, 0, 0, 0.2),
    0 6px 10px 0 rgba(0, 0, 0, 0.14),
    0 1px 18px 0 rgba(0, 0, 0, 0.12);
}
.app-header-toolbar {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
}
.header-title {
  min-width: 0;
  overflow: hidden;
  color: white;
  text-align: center;
  text-overflow: ellipsis;
  white-space: nowrap;
  pointer-events: none;
}
.header-actions {
  display: flex;
  min-width: 0;
  align-items: center;
}
.toolbar-homologacao {
  background-color: #f58634;
  color: #000;
  height: 50px;
}
.toolbar-i7code {
  background-color: #10aca0;
  color: #000;
  height: 50px;
}
.toolbar-idba {
  background-color: #00a19a;
  color: #000;
  height: 50px;
}
.toolbar-producao-idba {
  background-color: #005490;
  color: #000;
  height: 50px;
}
.toolbar-producao-tiberio {
  background-color: #d72e10;
  color: #000;
  height: 50px;
}
.toolbar-producao-menegon {
  background-color: #d72e10;
  color: #000;
  height: 50px;
}
.toolbar-producao-tiberio {
  background-color: #115c3b;
  color: #000;
  height: 50px;
}
.toolbar-producao-2cloud {
  background-color: #9182bd;
  color: #000;
  height: 50px;
}
.white-icon {
  color: white;
}
.location-selector {
  height: 42px !important;
  min-width: 0 !important;
  max-width: 310px;
  flex: 0 1 310px;
  margin-right: 8px;
  padding: 2px 8px !important;
  border: 1px solid rgba(255, 255, 255, 0.72);
  border-radius: 6px !important;
  color: white !important;
  line-height: normal !important;
}
.location-selector:hover {
  background: rgba(255, 255, 255, 0.1);
}
.location-selector .mat-icon {
  color: white;
}
::ng-deep .location-selector .mdc-button__label {
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: center;
}
.location-icon {
  width: 24px !important;
  height: 24px !important;
  margin-right: 6px;
  font-size: 24px !important;
}
.location-text {
  display: inline-flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
  align-items: flex-start;
  vertical-align: middle;
}
.location-caption {
  font-size: 10px;
  line-height: 12px;
  opacity: 0.82;
}
.location-name {
  display: block;
  width: 100%;
  overflow: hidden;
  font-size: 12px;
  line-height: 17px;
  text-align: left;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.location-arrow {
  width: 20px;
  height: 20px;
  margin-left: 5px !important;
  font-size: 20px;
}
::ng-deep .location-menu-panel.mat-mdc-menu-panel {
  width: 340px;
  max-width: calc(100vw - 24px) !important;
}
.location-menu-header {
  padding: 0px 10px 8px;
  color: #2f2f2f;
  font-size: 16px;
}
.location-search {
  display: flex;
  height: 40px;
  margin: 0 12px 8px;
  padding: 0 10px;
  border: 1px solid #bdbdbd;
  border-radius: 4px;
  align-items: center;
  gap: 8px;
}
.location-search:focus-within {
  border-color: #005490;
  box-shadow: 0 0 0 1px #005490;
}
.location-search mat-icon {
  color: #757575;
}
.location-search input {
  min-width: 0;
  border: 0;
  outline: 0;
  background: transparent;
  color: #333;
  flex: 1;
  font-size: 13px;
}
.location-menu-item {
  min-height: 56px !important;
  height: auto !important;
}
.location-menu-item-selected {
  background: #eef5fb !important;
}
.location-menu-item-content {
  display: flex;
  width: 100%;
  min-width: 0;
  align-items: center;
  gap: 8px;
}
:host ::ng-deep .mat-mdc-menu-content {
  padding: 0px !important;
}
.location-menu-item-text {
  display: flex;
  min-width: 0;
  flex: 1;
  flex-direction: column;
}
.location-menu-item-name,
.location-menu-item-detail {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.location-menu-item-name {
  color: #2f2f2f;
  font-size: 13px;
}
.location-menu-item-detail {
  margin-top: 2px;
  color: #757575;
  font-size: 10px;
}
.location-check {
  margin-right: 0 !important;
  color: #005490;
}
.location-menu-state {
  display: flex;
  min-height: 64px;
  padding: 12px 16px;
  color: #666;
  font-size: 12px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  text-align: center;
}
.location-menu-error {
  flex-wrap: wrap;
}
.location-menu-error mat-icon {
  color: #d84315;
}
.location-loading {
  width: 16px;
  height: 16px;
  border: 2px solid #d5e3ef;
  border-top-color: #005490;
  border-radius: 50%;
  animation: location-spin 0.7s linear infinite;
}
@keyframes location-spin {
  to {
    transform: rotate(360deg);
  }
}
.avatar-button {
  flex: 0 0 auto;
  padding: 0 8px !important;
  min-width: auto !important;
}
.avatar-content {
  display: inline-flex !important;
  flex-direction: row !important;
  align-items: center !important;
  gap: 8px;
  vertical-align: middle;
  white-space: nowrap;
}
.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  display: block;
  flex-shrink: 0;
}
.ml-2 {
  margin-left: 8px;
  color: black;
  font-size: 14px;
}
@media (max-width: 900px) {
  .location-selector {
    max-width: 220px;
  }
}
@media (max-width: 700px) {
  .location-caption {
    display: none;
  }
  .location-selector {
    height: 36px !important;
    max-width: 170px;
  }
}
@media (max-width: 560px) {
  .location-selector {
    min-width: 44px !important;
    width: 44px;
    padding: 0 !important;
  }
  ::ng-deep .location-selector .mdc-button__label {
    display: none;
  }
  .location-text,
  .location-arrow {
    display: none;
  }
  .location-icon {
    margin: 0 !important;
  }
}
/*# sourceMappingURL=header.component.css.map */
